import * as appTypes from './appTypes';
import { recomposeColor } from '@mui/material';
import { template } from 'lodash';

const initialState = {
  appLoading: true,
  file: null,
  isLoading: false,
  tokenAppointment: [],
  patient: [],
  patients: [],
  patientById: [],
  patientInfoById: [],
  treatment: [],
  upload: [],
  billing: [],
  billings: [],
  billings: [],
  TagByPatientId: [],
  tags: [],
  medicalRecord: [],
  medicalRecordsByPatientId: [],
  followupByPatientId: [],
  medicalReordsById: [],
  medicalRecords: [],
  tokenAppointments: [],
  tokenAppointmentsById: [],
  tokenappointmentsByPatientId: [],
  updateStatusRecord: [],
  getTemplateByClinicId: [],
  template: [],
  followup: [],
  billingsByPatientId: [],
  message: [],
  messagesByPatientId: [],
  reportsByPatientId: [],
  viewReportsById: [],
  downloadReportsById: [],
  treatmentsByPatientId: [],
  treatmentsById: [],
  doctprofile: [],
  clinicProfile: [],
  getDoctProfileById: [],
  getavailability: [],
  getClinicProfileById: [],
  AreaByPatientId: [],
  updatePatientById: [],
  updatePatientInfoById: [],
  updateTagbyid: [],
  updateAreabyid: [],
  area: [],
  tag: [],
  areas: [],
  patientinfo: [],
  staff: [],
  staffs: [],
  pclinic: [],
  gclinic: [],
  patientHistory: [],
  comment: [],
  task: [],
  tasks: [],
  summary: [],
  googleRedirectUrl: [],
  summarystat: [],
  monthlyappointments: [],
  taskoverview: [],
  appointmentstatussummary: [],
  transactions: [],
  pendingtransactions: [],
  avgEarningAndFollowUpRate: [],
  billingsById: [],
  uploadlogo: [],
  profilePic: [],
  availabilities: [],
  availableSlots: [],
  clinicById: [],
  getclinicByid: [],
  clinics: {
    data: [],
    currentClinic: {},
    clinicId: 0,
    doctorId: 0,
  },
};
export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case appTypes.SET_APP_LOADING:
      return { ...state, appLoading: payload.loading };

    //post & GET appointment
    case appTypes.POST_APPOINTMENT_REQUEST:
      return {
        ...state, isLoading: true, error: null,
      };
    case appTypes.POST_APPOINTMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenAppointment: [...state.tokenAppointment, payload.data],
      };
    case appTypes.POST_APPOINTMENT_FAILURE:
      return { ...state, isLoading: false, error: payload.error };

    case appTypes.GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenAppointments: payload.data
      };
    case appTypes.GET_APPOINTMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    case appTypes.GET_APPOINTMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenAppointmentsById: payload
      }
    case appTypes.GET_APPOINTMENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //GET APPOINTMENTS BY PATIENT ID
    case appTypes.GET_APPOINTMENT_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenappointmentsByPatientId: payload,
      }
    case appTypes.GET_APPOINTMENT_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //post patient

    case appTypes.POST_PATIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_PATIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patient: [...state.patient, payload.data],
      }
    case appTypes.POST_PATIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //get patient
    case appTypes.GET_PATIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patients: payload.data
      };
    case appTypes.GET_PATIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //Get Patient By Id
    case appTypes.GET_PATIENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patientById: payload
      }
    case appTypes.GET_PATIENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //Update Patient BY Id
    case appTypes.UPDATE_PATIENT_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_PATIENT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        updatePatientById: payload.data,
      }
    case appTypes.UPDATE_PATIENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };
    //POST PATIENT INFO
    case appTypes.POST_PATIENTINFO_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_PATIENTINFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patientinfo: [...state.patientinfo, payload.data],
      }
    case appTypes.POST_PATIENTINFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET PATIENTINFO BY PATIENT ID
    case appTypes.GET_PATIENTINFO_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patientInfoById: payload
      }
    case appTypes.GET_PATIENTINFO_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //Update PatientInfo BY Id
    case appTypes.UPDATE_PATIENTINFO_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_PATIENTINFO_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        updatePatientInfoById: payload.data,
      }
    case appTypes.UPDATE_PATIENTINFO_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //POST TAG
    case appTypes.POST_TAG_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_TAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tag: [...state.tag, payload.data],
      }
    case appTypes.POST_TAG_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET TAG BY PATIENT ID
    case appTypes.GET_TAG_BY_PATIENT_ID_SUCCESS:
      console.log("here is reducer response:", payload)
      return {
        ...state,
        isLoading: false,
        TagByPatientId: payload,
      }
    case appTypes.GET_TAG_BY_PATIENT_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //GET ALL TAGS
    case appTypes.GET_TAGS_SUCCESS:
      console.log("here is reducer of all tags response:", payload)
      return {
        ...state,
        isLoading: false,
        tags: payload,
      }
    case appTypes.GET_TAGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //Update Tag BY Id
    case appTypes.UPDATE_TAG_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_TAG_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        updateTagbyid: payload.data,
      }
    case appTypes.UPDATE_TAG_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //POST AREA
    case appTypes.POST_AREA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_AREA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        area: [...state.area, payload.data],
      }
    case appTypes.POST_AREA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET AREA BY PATIENT ID
    case appTypes.GET_AREA_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        AreaByPatientId: payload,
      }
    case appTypes.GET_AREA_BY_PATIENT_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //GET ALL AREAS

    case appTypes.GET_AREAS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        areas: payload,
      }
    case appTypes.GET_AREAS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //Update AREA BY Id
    case appTypes.UPDATE_AREA_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_AREA_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        updateAreabyid: payload.data,
      }
    case appTypes.UPDATE_AREA_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //POST Medical Records
    case appTypes.POST_MEDICALRECORD_REQUEST:
      return {
        ...state, isLoading: true, error: null,
      };
    case appTypes.POST_MEDICALRECORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        medicalRecord: [...state.medicalRecord, payload.data],
      };
    case appTypes.POST_MEDICALRECORD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };
    //GET MEDICAL RECORDS BY PATIENT ID
    case appTypes.GET_MEDICALRECORD_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        medicalRecordsByPatientId: payload,
      }
    case appTypes.GET_MEDICALRECORD_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET MEDICAL RECORDS BY ID
    case appTypes.GET_MEDICALRECORD_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        medicalReordsById: payload,
      }
    case appTypes.GET_MEDICALRECORD_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET TEMPLATE BY CLINIC ID
    case appTypes.GET_TEMPLATE_BY_CLINICID_REQUEST:
      return {
        ...state,
        isLoading: true,
        getTemplateByClinicId: [],
      }
    case appTypes.GET_TEMPLATE_BY_CLINICID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getTemplateByClinicId: payload,
      }
    case appTypes.GET_TEMPLATE_BY_CLINICID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
        getTemplateByClinicId: [],
      }

    case appTypes.POST_TEMPLATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,

      }
    case appTypes.POST_TEMPLATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        template: [...state.template, payload]
      }
    case appTypes.POST_TEMPLATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    case appTypes.POST_FOLLOWUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,

      }
    case appTypes.POST_FOLLOWUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        followup: [...state.followup, payload]
      }
    case appTypes.POST_FOLLOWUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    case appTypes.GET_FOLLOWUP_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        followupByPatientId: payload,
      }
    case appTypes.GET_FOLLOWUP_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //DELETE MEDICAL RECORDS
    case appTypes.DELETE_MEDICALRECORD_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        medicalRecordsByPatientId: Array.isArray(state.medicalRecordsByPatientId)
          ? state.medicalRecordsByPatientId.filter((medicalRecord) => medicalRecord.id !== payload.id)
          : [],
      }
    case appTypes.DELETE_MEDICALRECORD_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //Update statusrecord
    case appTypes.UPDATE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateStatusRecord: payload.data,
      }
    case appTypes.UPDATE_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //POST Billing
    case appTypes.POST_BILLING_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_BILLING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billing: [...state.billing, payload.data],
      }
    case appTypes.POST_BILLING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET BILLINGS BY PATIENT ID
    case appTypes.GET_BILLINGS_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billingsByPatientId: payload,
      }
    case appTypes.GET_BILLINGS_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //POST MESSAGE
    case appTypes.POST_MESSAGE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,

      }
    case appTypes.POST_MESSAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        message: [...state.message, payload]
      }
    case appTypes.POST_MESSAGE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET MESSAGE BY PATIENT ID
    case appTypes.GET_MESSAGE_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        messagesByPatientId: payload,
      }
    case appTypes.GET_MESSAGE_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //DELETE MESSAGE BY ID
    case appTypes.DELETE_MESSAGE_BY_ID_SUCCESS:
      console.log('Payload inside reducer message:', payload);
      return {
        ...state,
        isLoading: false,
        messagesByPatientId: Array.isArray(state.messagesByPatientId)
          ? state.messagesByPatientId.filter((message) => String(message.id) !== String(payload))
          : state.messagesByPatientId,
      };

    case appTypes.DELETE_MESSAGE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //POST REPORT
    case appTypes.POST_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case appTypes.POST_UPLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        upload: [...state.upload, payload.data], // <-- add payload.data here
      };

    case appTypes.POST_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };

    //POST REPORT
    case appTypes.POST_UPLOADLOGO_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case appTypes.POST_UPLOADLOGO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        uploadlogo: [...state.uploadlogo, payload.data],
      };

    case appTypes.POST_UPLOADLOGO_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };

    //POST PROFILEPIC
    case appTypes.POST_PROFILEPIC_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case appTypes.POST_PROFILEPIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profilePic: [...state.profilePic, payload.data],
      };

    case appTypes.POST_PROFILEPIC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };

    //GET REPORT BY PATIENT ID
    case appTypes.GET_REPORT_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reportsByPatientId: payload,
      }
    case appTypes.GET_REPORT_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //GET VIEW REPORT BY ID
    case appTypes.GET_VIEWREPORT_BY_ID_SUCCESS:

      return {
        ...state,
        isLoading: false,
        viewReportsById: payload,
      }
    case appTypes.GET_VIEWREPORT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //GET DOWNLOAD REPORT BY ID
    case appTypes.GET_DOWNLOADREPORT_BY_ID_SUCCESS:
      console.log("Success Payload reducer:", payload);
      return {
        ...state,
        isLoading: false,
        downloadReportsById: payload,
      }
    case appTypes.GET_DOWNLOADREPORT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //POST TREATMENT
    case appTypes.POST_TREATMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_TREATMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        treatment: [...state.treatment, payload.data],
      }
    case appTypes.POST_TREATMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET TREATMENT BY PATIENT ID
    case appTypes.GET_TREATMENT_BY_PATIENTID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        treatmentsByPatientId: payload,
      }
    case appTypes.GET_TREATMENT_BY_PATIENTID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //GET TREATMENT BYID
    case appTypes.GET_TREATMENT_BY_ID_SUCCESS:
      console.error('Treatments by id', payload);

      return {
        ...state,
        isLoading: false,
        treatmentsById: payload
      }
    case appTypes.GET_TREATMENT_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //POST DOCTOR PROFILE
    case appTypes.POST_DOCTORPROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_DOCTORPROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        doctprofile: [...state.doctprofile, payload.data],
      }
    case appTypes.POST_DOCTORPROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET DOCTOR PROFILE BY ID
    case appTypes.GET_DOCTORPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getDoctProfileById: payload,
      }
    case appTypes.GET_DOCTORPROFILE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //POST CLINIC PROFILE
    case appTypes.POST_CLINICPROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_CLINICPROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clinicProfile: [...state.clinicProfile, payload.data],
      }
    case appTypes.POST_CLINICPROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET CLINIC PROFILE BY ID
    case appTypes.GET_CLINICPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getClinicProfileById: payload,
      }
    case appTypes.GET_CLINICPROFILE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //POST STAFF
    case appTypes.POST_STAFF_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_STAFF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        staff: [...state.staff, payload.data],
      }
    case appTypes.POST_STAFF_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET STAFF
    case appTypes.GET_STAFF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        staffs: payload.data
      }
    case appTypes.GET_STAFF_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //POST CLINIC
    case appTypes.POST_CLINIC_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_CLINIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pclinic: [...state.pclinic, payload.data],
      }
    case appTypes.POST_CLINIC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET CLINIC
    case appTypes.GET_CLINIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        gclinic: payload.data
      }
    case appTypes.GET_CLINIC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }
    //Get Clinic By Id
    case appTypes.GET_CLINIC_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getclinicByid: payload
      }
    case appTypes.GET_CLINIC_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //Update CLINIC BY ID
    case appTypes.UPDATE_CLINIC_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.UPDATE_CLINIC_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        clinicById: payload.data,
      }
    case appTypes.UPDATE_CLINIC_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    //GET PATIENT HISTORY BY PATIENT ID
    case appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patientHistory: payload,
      }
    case appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //POST TASKS
    case appTypes.POST_TASK_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_TASK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        task: [...state.task, payload.data],
      }
    case appTypes.POST_TASK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //GET TASKS
    case appTypes.GET_TASK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tasks: payload
      }
    case appTypes.GET_TASK_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_BILLING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billings: payload
      }
    case appTypes.GET_BILLING_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        summary: payload
      }
    case appTypes.GET_SUMMARY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_GOOGLE_AUTH_URL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        googleRedirectUrl: payload.url,
      };

    case appTypes.GET_GOOGLE_AUTH_URL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };

    //POST COMMENT
    case appTypes.POST_TASKCOMMENT_BY_TASKID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case appTypes.POST_TASKCOMMENT_BY_TASKID_SUCCESS:
      const { taskId, message } = payload;

      if (!taskId || !message) {
        console.error('Invalid comment payload:', payload);
        return state;
      }
      return {
        ...state,
        loading: false,
        tasks: state.tasks.map((task) =>
          task.id === taskId
            ? { ...task, comments: [...(task.comments || []), message] }
            : task
        ),
      };

    case appTypes.POST_TASKCOMMENT_BY_TASKID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };
    //get Availibity
    case appTypes.FETCH_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getavailability: [...state.getavailability, payload.data],
      };
    case appTypes.FETCH_AVAILABILITY_FAILURE:
      return { ...state, isLoading: false, error: payload.error, getavailability: [] };
    case appTypes.SET_CLINICS:
      return {
        ...state,
        clinics: {
          ...state.clinics,
          data: payload.data?.data || [],
          meta: payload.data?.meta || {},
        },
      };

    case appTypes.GET_SUMMARYSTAT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        summarystat: payload.payload.data
      }
    case appTypes.GET_SUMMARYSTAT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_MONTHLYAPPOINTMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        monthlyappointments: payload?.payload?.data?.data,
      }
    case appTypes.GET_MONTHLYAPPOINTMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_TASKOVERVIEW_SUCCESS:
      return {
        ...state,
        isLoading: false,
        taskoverview: payload?.payload?.data
      }
    case appTypes.GET_TASKOVERVIEW_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_APPOINTMENTSTATUSSUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        appointmentstatussummary: payload?.payload?.data?.data
      }
    case appTypes.GET_APPOINTMENTSTATUSSUMMARY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transactions: payload?.payload?.data?.data
      }
    case appTypes.GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_PENDINGTRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pendingtransactions: payload?.payload?.data?.data
      }
    case appTypes.GET_PENDINGTRANSACTIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        avgEarningAndFollowUpRate: payload?.payload?.data?.data
      }
    case appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    //post availability
    case appTypes.POST_AVAILABILITY_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case appTypes.POST_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        availabilities: [...state.availabilities, payload.data],
      }
    case appTypes.POST_AVAILABILITY_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET BILLINGS BY ID
    case appTypes.GET_BILLING_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billingsById: payload,
      }
    case appTypes.GET_BILLING_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    case appTypes.GET_AVAILABLE_SLOTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        availableSlots: payload?.payload?.data?.slots || []
      };
    case appTypes.GET_AVAILABLE_SLOTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      };

    case appTypes.SET_CURRENT_CLINIC:
      const { clinicId, doctorId } = payload?.data || {};
      const currentClinic = state.clinics.data?.find((clinic) => clinic.id === clinicId) ?? {};
      return { ...state, clinics: { ...state.clinics, currentClinic, clinicId, doctorId } };

    case appTypes.SET_SELECTED_PATIENT:
      return {
        ...state,
        selectedPatient: payload,
      };

    case appTypes.FETCH_TOKENAPPOINTMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tokenAppointment: payload?.data || payload || [],
      };

    case appTypes.FETCH_PATIENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        patients: payload?.data || payload || [],
      };

    case appTypes.FETCH_TASKS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tasks: payload?.data || payload || [],
      };

    case appTypes.FETCH_STAFFS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        staffs: payload?.data || payload || [],
      };

    case appTypes.UPDATE_STAFF_SUCCESS:
      return {
        ...state,
        isLoading: false,
        staff: payload?.staff || payload || null,
      };

    case appTypes.FETCH_DOCTORPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getDoctProfileById: payload?.data || payload || null,
      };

    case appTypes.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profile: payload?.data || payload || null,
      };

    case appTypes.FETCH_CLINICPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getClinicProfileById: payload?.data || payload || null,
      };

    case appTypes.FETCH_MEDICALRECORD_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        medicalRecordsByPatientId: payload?.data || payload || [],
      };

    case appTypes.FETCH_BILLING_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        billingsByPatientId: payload?.data || payload || [],
      };

    case appTypes.FETCH_FOLLOWUP_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        followupByPatientId: payload?.data || payload || [],
      };

    case appTypes.FETCH_TREATMENT_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        treatmentsByPatientId: payload?.data || payload || [],
      };

    default:
      return state;
  }
};